// @ts-nocheck
import React, { useEffect, useMemo, useState } from 'react';
import { Layer, Source, useMap } from 'react-map-gl/mapbox';

import { getLimitsLineWeight, getTagFilters } from './helperAUX';

function DataLayer({
  country,
  id,
  indexLimits,
  layerMapData,
  opacity,
  paintLimits,
  promoteId,
  selectedItems = {},
  shape,
  tagFilters,
  type
}) {
  const layerName = 'layer';
  const { current: map } = useMap();
  const [{ isSourceReady }, setState] = useState({ isSourceReady: false });
  const sourceId = `cartography_${(country || '').toLowerCase()}_${shape}`;
  // @ts-ignore
  const tiles = useMemo(() => [`${taptap.config.mbtilesServer}${sourceId}/{z}/{x}/{y}.pbf`], [sourceId]);

  const setWeightToItem = ({ _id, color, w, ...rest }) => {
    map?.setFeatureState(
      {
        id: _id,
        source: sourceId,
        sourceLayer: layerName
      },
      {
        ...rest,
        [`layer_${id}_weight`]: w,
        [`layer_${id}_color`]: color
      }
    );
  };

  const selectedIds = Object.values(selectedItems)
    .filter(i => i.layerId === `layer_${id}`)
    .map(i => i.id);

  let layerOptions = {
    id: `layer_${id}`,
    key: `layer_${id}`
  };
  if (!paintLimits) {
    layerOptions = {
      ...layerOptions,
      paint: { 'fill-opacity': opacity },
      type: 'fill'
    };
    layerOptions.paint = {
      ...layerOptions.paint,
      'fill-color': ['feature-state', `layer_${id}_color`]
    };
  } else {
    layerOptions = {
      ...layerOptions,
      paint: {
        'line-color': '#ff0000',
        'line-dasharray': [3, 3],
        'line-opacity': getLimitsLineWeight(indexLimits.min, indexLimits.max, id),
        'line-width': 2
      },
      type: 'line'
    };
  }
  if (tagFilters) {
    layerOptions.filter = getTagFilters(tagFilters);
  }

  useEffect(() => {
    if (isSourceReady && map?.getSource(sourceId) && layerMapData) {
      layerMapData.forEach(item => {
        const itemValue = selectedIds.includes(item._id) ? 3000 : item.w;
        setWeightToItem({
          ...item,
          w: itemValue
        });
      });
    }
  }, [isSourceReady, layerMapData, sourceId, selectedIds]);

  const handleSourceData = () => {
    if (!isSourceReady && map?.getSource(sourceId) && map?.isSourceLoaded(sourceId)) {
      setState(prevState => ({
        ...prevState,
        isSourceReady: true
      }));
    }
  };

  map?.on('sourcedata', handleSourceData);

  return (
    <Source id={sourceId} key={`${sourceId}_${id}`} promoteId={promoteId} tiles={tiles} type={type}>
      <Layer {...layerOptions} source-layer={layerName} />
    </Source>
  );
}

export default DataLayer;
